
// Soft UI Dashboard React layouts
import Dashboard from "layouts/dashboard";
import { useTranslation } from "react-i18next";
// Soft UI Dashboard React icons
import Shop from "reusableComponents/Icons/Shop";
import Librarians from "./mainComponents/librarians/Librarians";
import Document from "./reusableComponents/Icons/Document";
import { FaUserTie } from "react-icons/fa6";
import PaymentList from "./mainComponents/payment/PaymentList";
import { FaFileInvoiceDollar } from "react-icons/fa6";
import AgentDigitizations from "layouts/agent-publications";
import { FaUsersCog } from 'react-icons/fa';
import ServicesList from "./layouts/services/ServicesList";
import { MdMiscellaneousServices } from "react-icons/md";
import FeedbackList from "./reusableComponents/Feedback/FeedbackList";
import { VscFeedback } from "react-icons/vsc";
import ReportIssues from "./mainComponents/reportIssues/ReportIssues";
import ManageReportedIssues from "./mainComponents/reportIssues/ManageReportedIssues";
import ManageAiAssistant from "./mainComponents/AIAssistantManagement/ManageAiAssistant";

export default function sideBarItems() {
    const { t, i18n } = useTranslation('sideNav');
    const currentLang = i18n.language;

    const p = (path) => `/${currentLang}${path}`;

    return {
    'super-admin':
        [
            {
                type: "collapse",
                name: "Dashboard",
                key: "dashboard",
                route: p("/dashboard"),
                icon: <Shop size="12px"/>,
                component: <Dashboard/>,
                noCollapse: true,
            },
            {
                type: "collapse",
                name: "Manage free agents",
                key: "free-agents",
                route: p("/free-agents"),
                icon:<FaUsersCog size="14px" />,
                component: <Librarians/>,
                noCollapse: true,
            },
            {
                type: "collapse",
                name: "Agent Digitizations",
                key: "agent-digitizations",
                route: p("/agent-digitizations"),
                icon: <FaUserTie size="12px"/>,
                component: <AgentDigitizations/>,
                noCollapse: true,
            },
            {
                type: "collapse",
                name: "Payment list",
                key: "payment-list",
                route: p("/payment-list"),
                icon: <FaFileInvoiceDollar size="12px"/>,
                component: <PaymentList/>,
                noCollapse: true,
            },
            {
            type: "collapse",
            name: "Services List",
            key: "services-list",
            route: p("/services-list"),
            icon: <MdMiscellaneousServices size="12px"/>,
            component: <ServicesList />,
            noCollapse: true,
            },
            {
                type: "collapse",
                name: "Manage feedback List",
                key: "feedback-list",
                route: p("/feedback-list"),
                icon: <VscFeedback size="12px"/>,
                component: <FeedbackList />,
                noCollapse: true,
            },
            {
                type: "collapse",
                name: t('manage issues', {ns:'sideNav'}),
                key: "manage-issues",
                route: p('/manage-issues'),
                icon: <VscFeedback size="12px"/>,
                component: <ManageReportedIssues />,
                noCollapse: true,
            },
            {
                type: "collapse",
                // name: t('manage issues', {ns:'sideNav'}),
                name: "Manage AI Assistant",
                key: "manage-assistant",
                route: p('/manage-assistant'),
                icon: <VscFeedback size="12px"/>,
                component: <ManageAiAssistant />,
                noCollapse: true,
            }
        ],
    'free-agent':
        [
            {
                type: "collapse",
                name: t('dashboard', {ns:'sideNav'}),
                key: "dashboard",
                route: p('/dashboard'),
                icon: <Shop size="12px"/>,
                component: <Dashboard/>,
                noCollapse: true,
            },
            {
                type: "collapse",
                name: t('digitalDatabase', {ns:'sideNav'}),
                key: "documents",
                route: p('/documents'),
                icon: <Document size="12px" />,
                noCollapse: true,
            },
            {
                type: "collapse",
                name: t('invoices', {ns:'sideNav'}),
                key: "invoices",
                route: p('/invoices'),
                icon: <FaFileInvoiceDollar size="12px"/>,
                component: <PaymentList/>,
                noCollapse: true,
            },
            {
                type: "collapse",
                name: t('report issues', {ns:'sideNav'}),
                key: "report-issues",
                route: p('/report-issues'),
                icon: <VscFeedback size="12px"/>,
                component: <ReportIssues />,
                noCollapse: true,
            }
        ]
    };
}

